import type { PersonalRoutine } from "../personal-routine";

export const defaultPersonalRoutine: PersonalRoutine = {
  name: "Controllo prioritario",
  frequency: "Ogni giorno",
  time: "09:00",
  instructions: "Controlla le attività urgenti di Alfa S.r.l. e indicami la prossima azione.",
  proposeInChat: false,
};
